/* Retro Reflections — tile fitting core. Shared by the public planner and the internal tool.
   Tiles 40x40cm, 6 per box. All dimensions in cm. */
window.RetroCalc = (function(){
  var TILE = 40, PER_BOX = 6;

  function rectsFor(shape, W, H, rW, rH, pos){
    if (shape === 'rect') return [{x0:0,y0:0,x1:W,y1:H}];
    var rx0 = pos === 'left' ? 0 : (pos === 'right' ? W - rW : (W - rW)/2);
    return [{x0:0,y0:0,x1:W,y1:H},{x0:rx0,y0:H,x1:rx0+rW,y1:H+rH}];
  }

  function ov(a0,a1,b0,b1){ return Math.max(0, Math.min(a1,b1) - Math.max(a0,b0)); }

  /* vMode: 'cupboard' anchors a grid line on the underside of the wall units (y = H),
     so the top row under the cupboards is a full tile and the offcut falls at the worktop.
     'worktop' starts a full tile on the worktop and cuts under the cupboards. */
  function fit(rects, hMode, vMode, H){
    var maxX = 0, maxY = 0, i;
    for (i=0;i<rects.length;i++){ maxX = Math.max(maxX, rects[i].x1); maxY = Math.max(maxY, rects[i].y1); }
    var x0 = 0;
    if (hMode === 'centre') x0 = -((Math.ceil(maxX/TILE)*TILE) - maxX)/2;
    var y0 = 0;
    if (vMode === 'cupboard') y0 = H - Math.ceil(H/TILE)*TILE;

    var cells = [];
    for (var gx = x0; gx < maxX - 1e-9; gx += TILE){
      for (var gy = y0; gy < maxY - 1e-9; gy += TILE){
        var area = 0, hits = 0, cw = 0, ch = 0;
        for (i=0;i<rects.length;i++){
          var w = ov(gx,gx+TILE,rects[i].x0,rects[i].x1);
          var h = ov(gy,gy+TILE,rects[i].y0,rects[i].y1);
          if (w*h > 0.01){ area += w*h; hits++; cw = Math.max(cw,w); ch = Math.max(ch,h); }
        }
        if (area <= 0.01) continue;
        var full = Math.abs(area - TILE*TILE) < 0.01;
        cells.push({ gx:gx, gy:gy, full:full, shaped: hits > 1 && !full,
                     cw:Math.round(cw*10)/10, ch:Math.round(ch*10)/10 });
      }
    }
    var shapeArea = 0;
    for (i=0;i<rects.length;i++) shapeArea += (rects[i].x1-rects[i].x0)*(rects[i].y1-rects[i].y0);
    var fullT = 0;
    for (i=0;i<cells.length;i++) if (cells[i].full) fullT++;
    return { cells:cells, x0:x0, y0:y0, maxX:maxX, maxY:maxY,
             shapeArea: shapeArea/10000, tiles: cells.length,
             fullTiles: fullT, cuts: cells.length - fullT };
  }

  function cutList(cells){
    var m = {}, order = [];
    cells.forEach(function(c){
      if (c.full) return;
      var k = c.shaped ? 'shaped' : (c.cw + ' × ' + c.ch);
      if (!m[k]) { m[k] = 0; order.push(k); }
      m[k]++;
    });
    order.sort(function(a,b){ return m[b] - m[a]; });
    return order.map(function(k){ return { size:k, qty:m[k] }; });
  }

  function geom(res, maxW){
    var pad = 26, sc = Math.min((maxW || 640) / (res.maxX - res.x0), 3);
    return { pad:pad, sc:sc,
             w:(res.maxX - res.x0)*sc + pad*2,
             h:(res.maxY - res.y0)*sc + pad*2 };
  }

  function svg(res, rects, maxW){
    var g = geom(res, maxW);
    var X = function(x){ return g.pad + (x - res.x0) * g.sc; };
    var Y = function(y){ return g.h - g.pad - (y - res.y0) * g.sc; };
    var s = '<svg viewBox="0 0 ' + g.w.toFixed(0) + ' ' + g.h.toFixed(0) + '" xmlns="http://www.w3.org/2000/svg">';
    s += '<rect width="100%" height="100%" fill="#FDFBF7"/>';
    res.cells.forEach(function(c){
      s += '<rect x="' + X(c.gx).toFixed(1) + '" y="' + Y(c.gy+TILE).toFixed(1) +
           '" width="' + (TILE*g.sc).toFixed(1) + '" height="' + (TILE*g.sc).toFixed(1) +
           '" fill="' + (c.full ? '#EADBC5' : '#C9B79B') + '" stroke="#FDFBF7" stroke-width="1.5"/>';
    });
    rects.forEach(function(r){
      s += '<rect x="' + X(r.x0).toFixed(1) + '" y="' + Y(r.y1).toFixed(1) +
           '" width="' + ((r.x1-r.x0)*g.sc).toFixed(1) + '" height="' + ((r.y1-r.y0)*g.sc).toFixed(1) +
           '" fill="none" stroke="#141C2E" stroke-width="2"/>';
    });
    s += '</svg>';
    return s;
  }

  return { TILE:TILE, PER_BOX:PER_BOX, rectsFor:rectsFor, fit:fit, cutList:cutList, svg:svg, geom:geom };
})();